// extracted by mini-css-extract-plugin
export default {"form":"CreateTaskForm_form__skXbP","content":"CreateTaskForm_content__-j6xx","field":"CreateTaskForm_field__ErNBA"};